import React, { useEffect, useState } from "react";
import NotAuthorized from "../NotAuthorized/NotAuthorized";
import CheckRole from "../../Utils/CheckRole/CheckRole";
import { useSelector, useDispatch } from "react-redux";
import { getAllTasks, operaterResponseToBroadcast, operaterResponseMarkAsComplete } from "../../Features/OperatorHome/OperatorHomeSlice";
import { useNavigate, useParams, Link } from "react-router-dom";
import { TiTick } from "react-icons/ti";
import { ImCross } from "react-icons/im";

import Loader from '../../Components/Loader/Loader';
import DataTable from '../../Components/DataTable/DataTable';

const OperatorHome = () => {
  const { allTasks } = useSelector((store) => store.operatorHome);
  const [loading, setLoading] = useState(true);
  const [activeList, setActiveList] = useState("activeJobs");
  const { user } = useSelector((store) => store.auth);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    const fetchData = async () => {
      await dispatch(getAllTasks());
      setLoading(false);
    };
    fetchData();
  }, [dispatch]);

  const allJobs = allTasks?.flat() || [];
  
  // Filter projects with isBroadcast key set to 1
  const broadcastProjects = allJobs.filter(project => project.isBroadcast === 1);

  // Sort projects based on status (active, accepted, rejected, completed)
  broadcastProjects.sort((a, b) => {
    if (a.isActive !== b.isActive) {
      return b.isActive - a.isActive; // Active jobs first
    }
    if (a.isActive && b.isActive) {
      return a.isCompleted - b.isCompleted; // Completed jobs next
    }
    if (a.isCompleted !== b.isCompleted) {
      return a.isCompleted - b.isCompleted; // Accepted jobs next
    }
    if (a.isRejected !== b.isRejected) {
      return a.isRejected - b.isRejected; // Rejected jobs next
    }
    return 0;
  });

  const columns = [
    { field: 'SrNo', headerName: 'Sr.No', minWidth: 100,flex:1 },
    { field: 'projectId', headerName: 'Project Id', minWidth: 150,flex:1},
    { field: 'name', headerName: 'Project Name', minWidth: 200,flex:1},
    {
      field: 'activeJobs',
      headerName: 'Active Jobs',
      minWidth: 200,flex:1,
      renderCell: (params) => {
        if (params.row.isBroadcast === 1 && params.row.isActive === 0 && params.row.isCompleted === 0 && params.row.isRejected === 0) {
          return <button className="deleteButton marginRight" onClick={() => dispatch(operaterResponseToBroadcast({ taskId: params.row.id, projectId: params.row.projectId, response: "accept" })).then(() => {dispatch(getAllTasks()); setActiveList("acceptedJobs")})}>Accept</button>;
        } else {
          return <div className="crossIcon"><ImCross/></div>;
        }
      }
    },
    {
      field: 'rejectedJobs',
      headerName: 'Rejected Jobs',
      minWidth: 200,flex:1,
      renderCell: (params) => {
        if (params.row.isBroadcast === 1 && params.row.isActive === 0 && params.row.isCompleted === 0 && params.row.isRejected === 1) {
          return <div className="deleteButton"><ImCross/></div>;
        } else {
          return <div className="crossIcon"><ImCross/></div>;
        }
      }
    },
    {
      field: 'acceptedJobs',
      headerName: 'Accepted Jobs',
      minWidth: 200,flex:1,
      renderCell: (params) => {
        if (params.row.isBroadcast === 1 && params.row.isActive === 1 && params.row.isCompleted === 0 && params.row.isRejected === 0) {
          return <button className="deleteButton marginRight" onClick={() => dispatch(operaterResponseMarkAsComplete({ id: params.row.id })).then(() => {dispatch(getAllTasks()); setActiveList("completedJobs")})}>Mark as Complete</button>;
        } else {
          return <div className="crossIcon"><ImCross/></div>;
        }
      }
    },
    {
      field: 'completedJobs',
      headerName: 'Completed Jobs',
      minWidth: 200,flex:1,
      renderCell: (params) => {
        if (params.row.isBroadcast === 1 && params.row.isActive === 0 && params.row.isCompleted === 1 && params.row.isRejected === 0) {
          return <div className="tickIcon"><TiTick /></div>;
        } else {
          return <div className="crossIcon"><ImCross/></div>;
        }
      }
    }
  ];

  // Add serial numbers to each row
  const allbroadcastProjects = broadcastProjects.map((project, index) => ({
    ...project,
    SrNo: index + 1
  }));

  return "operator" === CheckRole() ? (
    <div className="Group_CardContainer">
      {loading ? (
        <h5><Loader /></h5>
      ) : (
        <>
          {broadcastProjects.length === 0 ? (
            <h5>No jobs available yet</h5>
          ) : (
            <>
              <DataTable columns={columns} data={allbroadcastProjects} />
            </>
          )}
        </>
      )}
    </div>
  ) : (
    <NotAuthorized />
  );
};

export default OperatorHome;
